"use strict";

const menuToggle = document.querySelector(".menu");
const menu = document.querySelector(".section__nav");
const menuLinks = document.querySelectorAll(".menu__link");

if(menuToggle){
    // click sur le bouton
    menuToggle.addEventListener("click", menuOpen);

    // click sur les liens 
    for(let menuLink of menuLinks){
        menuLink.addEventListener("click", menuOpen);
    }
}
// function pour ouvrir et fermer le menu
function menuOpen(){
    menu.classList.toggle("menu--open");
}

//animation 
function revealOnScroll() {
    var elements = document.querySelectorAll(".reveal");
    var windowHeight = window.innerHeight;

    elements.forEach(function (el) {
        var elementTop = el.getBoundingClientRect().top;

        if (elementTop < windowHeight -50){
            el.classList.add("active");
        }
    });
}
window.addEventListener("scroll", revealOnScroll);
revealOnScroll();

//oeil

const eyeball = document.querySelector(".oeil__pupille");
const boutons = document.querySelectorAll(".group__link");

//si pas if eyball ereur sur les autre page
if (eyeball) {
    //ordi
document.onmousemove = () => {
    const x = event.clientX * 100/ window.innerWidth + "%";
    const y = event.clientY * 100/ window.innerWidth + "%";

    eyeball.style.left = x;
    eyeball.style.top = y;  
}

document.addEventListener ("touchmove", (event) => {
    const touch = event.touches[0]; //si un doigt sur l'ecrant

    const x = touch.clientX * 100/ window.innerWidth + "%";
    const y = touch.clientY * 100/ window.innerWidth + "%";

    eyeball.style.left = x;
    eyeball.style.top = y;  
});

boutons.forEach((bouton) => {
    bouton.addEventListener ("mouseover", () =>{
        eyeball.classList.add("oeil__pupille--zom");
    });

    bouton.addEventListener ("mouseleave", () =>{
        eyeball.classList.remove("oeil__pupille--zom");
    });
});
}